import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";
import Home from "./pages/Home";
import Apps from "./pages/Apps";
import HollerbachCaseStudy from "./pages/HollerbachCaseStudy";
import LaMarquetaCaseStudy from "./pages/LaMarquetaCaseStudy";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import AreniaCasinosCaseStudy from "./pages/AreniaCasinosCaseStudy";
import StFrancisCaseStudy from "./pages/StFrancisCaseStudy";
import OasizMallCaseStudy from "./pages/OasizMallCaseStudy";
import BeHotelesCaseStudy from "./pages/BeHotelesCaseStudy";
import PaymentsCanadaCaseStudy from "./pages/PaymentsCanadaCaseStudy";
import AniwaGatheringCaseStudy from "./pages/AniwaGatheringCaseStudy";
import Support from "./pages/Support";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import TermsAndConditions from "./pages/TermsAndConditions";
import Blog from "./pages/Blog";
import CatchAllOldBlog from "./pages/CatchAllOldBlog";
import GlobalSEO from "./components/GlobalSEO";

// Sends a GA4 page_view event whenever the route changes (SPA navigation).
const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location]);

  return null;
};

function App() {
  return (
    <BrowserRouter>
      <RouteChangeTracker />
      <GlobalSEO />
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/app" element={<Navigate to="/apps" replace />} />
            <Route path="/apps" element={<Apps />} />
            <Route path="/case-studies" element={<CaseStudiesPage />} />
            <Route path="/case-studies/hollerbach-oktoberfest" element={<HollerbachCaseStudy /> } />
            <Route path="/case-studies/la-marqueta" element={<LaMarquetaCaseStudy />} />
            <Route path="/case-studies/arenia-casinos" element={<AreniaCasinosCaseStudy />} />
            <Route path="/case-studies/st-francis-donor-event" element={<StFrancisCaseStudy />} />
            <Route path="/case-studies/oasiz-mall" element={<OasizMallCaseStudy />} />
            <Route path="/case-studies/behoteles" element={<BeHotelesCaseStudy />} />
            <Route path="/case-studies/payments-canada" element={<PaymentsCanadaCaseStudy />} />
            <Route path="/case-studies/aniwa-gathering" element={<AniwaGatheringCaseStudy />} />
            <Route path="/support" element={<Support />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="*" element={<CatchAllOldBlog />} />
          </Routes>
        </main>
        <Footer />
        <CookieConsent />
        <Toaster position="top-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
